import React from 'react';
import PropTypes from 'prop-types';
import { AppBadge } from '@easyllama/ui-components';
import RowShell from '../atoms/RowShell';
import { buildRow, closeOnPlainClick } from '../helpers';

function highlightMatch(text, term) {
  if (!text || !term) return text;
  const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = String(text).split(new RegExp(`(${escaped})`, 'gi'));
  if (parts.length === 1) return text;
  return parts.map((part, index) => (index % 2 === 1
    ? <span key={index} className="font-extrabold text-llama-purple-6">{part}</span>
    : part));
}

function GlobalSearchResultRow({ type, row, term, active, onHover, innerRef, onNavigate }) {
  const data = buildRow(type, row);

  return (
    <RowShell active={active} onHover={onHover} innerRef={innerRef}>
      <span className="flex size-8 shrink-0 items-center justify-center">
        {data.avatarInitial && (
          <span className="flex size-8 items-center justify-center rounded-full bg-llama-purple-2 text-xs font-bold text-llama-purple-6">
            {data.avatarInitial}
          </span>
        )}
      </span>
      <div className="min-w-0 flex-1">
        {/* Plain anchor, not AppLink: its flex layout breaks truncation once highlightMatch splits the title into nodes. */}
        <a
          href={data.url}
          onClick={(event) => closeOnPlainClick(event, onNavigate)}
          className="block truncate text-sm font-semibold text-llama-grey-7 hover:underline"
        >
          {highlightMatch(data.title, term)}
        </a>
        {data.subtitle && <p className="truncate text-[length:var(--gs-subtitle-font)] font-normal text-llama-grey-5">{highlightMatch(data.subtitle, term)}</p>}
      </div>
      <span className="relative flex flex-none items-center gap-3">
        <span className="flex items-center gap-3">
          {data.tagBadge && (
            <AppBadge type="tag" color="informational" appearance="standard">
              {data.tagBadge.label}
            </AppBadge>
          )}
          {data.statusBadge && (
            <AppBadge type="status" color={data.statusBadge.color}>
              {data.statusBadge.label}
            </AppBadge>
          )}
        </span>
        {data.meta && (
          <span className="min-w-[84px] text-right text-xs font-medium text-llama-grey-5">{highlightMatch(data.meta, term)}</span>
        )}
      </span>
    </RowShell>
  );
}

GlobalSearchResultRow.propTypes = {
  type: PropTypes.string.isRequired,
  row: PropTypes.object.isRequired,
  term: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onHover: PropTypes.func.isRequired,
  innerRef: PropTypes.func,
  onNavigate: PropTypes.func.isRequired,
};

export default GlobalSearchResultRow;
